import { useEffect, useState } from "react";

// Returns `value` only after it has stopped changing for `delay` ms (used for search boxes)
export function useDebounced(value, delay = 300) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);
  return debounced;
}

// A "Resend code" wait: start() after a code is sent; `left` counts the seconds down to 0, when resending is allowed
export function useResendTimer(seconds = 30) {
  const [until, setUntil] = useState(0);
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    if (!until) return undefined;
    const timer = setInterval(() => {
      const t = Date.now();
      setNow(t);
      if (t >= until) clearInterval(timer);
    }, 1000);
    return () => clearInterval(timer);
  }, [until]);
  const left = until ? Math.max(0, Math.ceil((until - now) / 1000)) : 0;
  const start = () => { setNow(Date.now()); setUntil(Date.now() + seconds * 1000); };
  return { left, start };
}

// 27 -> "0:27"
export const clock = (seconds) => `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")}`;
